@if (cells().length > 0) {
  <div class="astro-points" [style.--astro-point-count]="cells().length" data-test-id="astro-points">
    @for (cell of cells(); track cell.key) {
      <button
        type="button"
        class="astro-point"
        [title]="cell.tooltip"
        [attr.data-test-id]="'astro-point-' + cell.key"
        (click)="onClick(cell.key, $event)"
      >
        <span class="astro-point__glyph" aria-hidden="true">{{ cell.glyph }}</span>
        <span class="astro-point__gate">{{ cell.gate }}</span>
        <span class="astro-point__sub">
          <span class="astro-point__line">.{{ cell.line }}</span>
          @if (cell.colorTone) {
            <span class="astro-point__color-tone">{{ cell.colorTone }}</span>
          }
        </span>
      </button>
    }
  </div>
}
